/**
* Tab HTML
*/
class customTabs extends HTMLElement {
    constructor() {
      super();
  
      this.tabLinks = this.querySelectorAll('.tablink');
      this.tabContainers = this.querySelectorAll('.tabcontent');
  
      this.tabLinks.forEach( link => link.addEventListener('click', this.toggleTabs.bind(this)));
    }
  
    /**
     * Escape Key Press to close drawer when focus is within the container
     *
     * @param {event} Event instance
     */
    onKeyUp(event) {
      if(event.code.toUpperCase() !== 'ESCAPE') return;
    }
  
    /**
     * Toggle Tabs on link click
     *
     * @param {event} Event instance
     */
    toggleTabs(event){
      event.preventDefault();
      event.stopPropagation();
      const currentTab = event.currentTarget;
      const tabLink = currentTab.querySelector('[data-toggle="tab"]');
      const tabContainer = document.querySelector(tabLink.dataset.tabcontent);
  
      this.openTab(currentTab, tabContainer)
    }
  
    /**
     * Open Tab Container
     *
     * @param {Node} currentTab Tab Container Open link
     * @param {Node} tabContainer Tab Container to open
     */
    openTab(currentTab, tabContainer) {
      this.tabContainers.forEach(container => {
        container.classList.remove('open');
        const linkEle = document.querySelector('.tablink a[data-toggle="tab"][data-tabcontent="#'+container.id+'"]');
        if(linkEle){
          linkEle.setAttribute('aria-expanded', false);
          if(linkEle.closest('.tablink')){ linkEle.closest('.tablink').classList.remove('open');}
        }
      });
      currentTab.classList.add('open');
      currentTab.querySelector('[data-toggle="tab"]').setAttribute('aria-expanded', true);
      tabContainer.classList.add('open');
    }
  }
  customElements.define("custom-tabs", customTabs);
  
  /**
  * Accordion HTML
  */
  /**
  * Accordion HTML
  */
  class customAccordion extends HTMLElement {
    constructor() {
      super();
      this.accordionType = this.dataset.accordiontype;
      this.toggleBtns = this.querySelectorAll('.accordion__toggle');
  
      this.toggleBtns.forEach(button => button.addEventListener('click', this.toggleAccordionBlock.bind(this)));
    }
  
    /**
     * Escape Key Press to close drawer when focus is within the container
     *
     * @param {event} Event instance
     */
    onKeyUp(event) {
      if(event.code.toUpperCase() !== 'ESCAPE') return;
    }
  
    /**
     * Toggle Tabs on link click
     *
     * @param {event} Event instance
     */
     toggleAccordionBlock(event){
      event.preventDefault();
      const toggleBtn = event.currentTarget;
      const targetContainer = toggleBtn.parentNode;
      const isOpen = targetContainer.classList.contains('open');
      isOpen ? this.closeAccordionBlock(toggleBtn) : this.openAccordionBlock(toggleBtn);
    }
  
    /**
     * Open Tab Container
     *
     * @param {Node} toggleBtn Accordion Block Open link
     */
     openAccordionBlock(toggleBtn) {
      let targetContainer = toggleBtn.parentNode;
      toggleBtn.setAttribute('aria-expanded', true);
      Utility.toggleElement(targetContainer, 'open');
      if(this.accordionType == 'single'){
        let siblingBlocks = targetContainer.parentNode.querySelectorAll('.accordion__container');
        siblingBlocks.forEach(element => {
          if(element == targetContainer){ return; }
          element.classList.remove('open');
          element.querySelector('.accordion__block').classList.remove('open');
          element.querySelector('.accordion__toggle').setAttribute('aria-expanded', false);
        });
      }
      Utility.trapFocus(targetContainer);
    }
  
    /**
     * Close Tab Container
     *
     * @param {Node} currentTab Tab Container link
     * @param {Node} tabContainer Tab Container to close
     */
     closeAccordionBlock(toggleFilterBtn) {
      const targetContainer = toggleFilterBtn.parentNode;
      toggleFilterBtn.setAttribute('aria-expanded', false);
      Utility.toggleElement(targetContainer, 'close');
      Utility.removeTrapFocus(targetContainer);
    }
  }
  customElements.define("custom-accordion", customAccordion);
  
  /**
    * collaspsibleTab element Events and Methods
    *
    * @param {element} element - Dropdown element
    */
  function initCollaspsibleTab(element){
  
    /** Toggle each filter block container containing values for dropdown effect **/
    let tabToggleBtn = element.querySelector('.tab_toggle');
    tabToggleBtn.addEventListener('click', toggleTab.bind(this));
  
    /**
     * Toggle Filter drawer
     * @param {event} event 
    */
    function toggleTab(event) {
      event.preventDefault();
      const toggleFilterBtn = event.currentTarget;
      const filterContainer = toggleFilterBtn.closest('.tab_container');
      const isOpen = filterContainer.classList.contains('open');
      isOpen ? closeTab(toggleFilterBtn) : openTab(toggleFilterBtn);
    }
  
    /**
     * Open Filter Block
     * @param {element} toggleFilterBtn 
     */
     function openTab(toggleFilterBtn) {
      let filterContainer = toggleFilterBtn.closest('.tab_container');
      toggleFilterBtn.setAttribute('aria-expanded', true);
      Utility.toggleElement(filterContainer, 'open');
      Utility.trapFocus(filterContainer);
    }
  
    /**
     * Close Filter Block
     * @param {element} toggleFilterBtn 
     */
    function closeTab(toggleFilterBtn) {
      const filterContainer = toggleFilterBtn.closest('.tab_container');
      toggleFilterBtn.setAttribute('aria-expanded', false);
      Utility.toggleElement(filterContainer, 'close');
      Utility.removeTrapFocus(filterContainer);
    }
  }
  
  const allCollaspsibleTabs = document.querySelectorAll('[is="collaspsibleTab"]');
  allCollaspsibleTabs.forEach(function(ele) {
    initCollaspsibleTab(ele)
  });


  class customSelect extends HTMLElement{
    constructor() {
      super();
      this.selectContainer = this.querySelector('.custom-dropdown');
      this.select = this.querySelector('ul');
      this.initOption = this.querySelector('.default');
      this.options = this.select?.querySelectorAll('li');
      this.closefilterDrawer = this.querySelector("[data-closefilterDrawer]");
      this.sortBy = document.querySelector(".product-sorting__wrapper .sortby-dropdown .custom-dropdown") ?? null;
      this.filterBy = document.querySelector(".filter-dropdown .custom-dropdown") ?? null;

      this.filterBy?.addEventListener('click', () => {
        Utility.toggleElement(this.sortBy, 'close');
      });
      this.sortBy?.addEventListener('click', () => {
        Utility.toggleElement(this.filterBy, 'close');
      });
  
      this.options?.forEach(option => option.addEventListener('click', this.toggleOptions.bind(this)));
      this.initOption.addEventListener('click', this.manageVisibility.bind(this));

      // bind keydown so Enter works when component or any child is focused
      this._onKeyDownBound = this.onKeyDown.bind(this);
      this.addEventListener('keydown', this._onKeyDownBound);
      // also listen on document to catch key presses when focus is inside a deeper child (labels/inputs)
      document.addEventListener('keydown', (e) => {
        if (this.contains(document.activeElement)) this._onKeyDownBound(e);
      });

      this.addEventListener('click', (event) => {
        event.stopPropagation();
      });
      document.body.addEventListener('click', ()=> {
        Utility.toggleElement(this.selectContainer, 'close')
      });
      this.closefilterDrawer?.addEventListener('click', ()=> {
        Utility.toggleElement(this.selectContainer, 'close')
      });
    }
  
    onKeyDown(event){
      if(event.key !== 'Enter') return;

      const active = document.activeElement;

      // If focus is on the filter button itself, toggle visibility
      if(active.classList.contains('filter-label')) {
        event.preventDefault();
        event.stopPropagation(); // Stop event bubbling
        this.toggleFilterVisibility(active);
        return;
      }
      // If focus is inside an option <li>, trigger its click (this will run toggleOptions)
      const optionLi = active?.closest && active.closest('li');
      if(optionLi && this.options && Array.from(this.options).includes(optionLi)){
        event.preventDefault();
        optionLi.click();
        return;
      }
      // If focus is on the default toggle, toggle visibility
      if(this.initOption && (this.initOption.contains(active) || active === this.initOption)){
        event.preventDefault();
        this.initOption.click();
        return;
      }
      // If focus on a label or input inside an li, click the li
      if(active && (active.tagName === 'LABEL' || active.tagName === 'INPUT')){
        const li = active.closest('li');
        if(li){
          event.preventDefault();
          li.click();
        }
      }
    }

    // Add new method specifically for filter toggle
    toggleFilterVisibility(filterButton) {
      if (filterButton.getAttribute('aria-expanded') === 'true') {
        filterButton.setAttribute('aria-expanded', 'false');
      } else {
        filterButton.setAttribute('aria-expanded', 'true');
      }

      const container = filterButton.closest('.custom-dropdown');
      if (!container) return;
      
      const isOpen = container.classList.contains('open');
      isOpen ? Utility.toggleElement(container, 'close') : Utility.toggleElement(container, 'open');
    }

    /**
     * Toggle custom select option
     * @param event 
     */
    toggleOptions(event){
      const _this = event.currentTarget;
      // update visual selection
      this.options.forEach(option => option.classList.remove('selected'));
      _this.classList.add('selected');
      this.options.forEach(option => option.setAttribute('aria-selected', 'false'));
      _this.setAttribute('aria-selected', 'true');

      // update the underlying radio/input so change listeners run
      const input = _this.querySelector('input[type="radio"], input');
      if(input){
        // Use click() to trigger default behavior/listeners, fall back to change event
        try {
          input.click();
        } catch (e) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      // update label shown in the closed control
      const optionTxt = _this.querySelector('.option_txt');
      if(this.initOption && optionTxt){
        this.initOption.querySelector('.option_txt').innerHTML = optionTxt.innerHTML;
      }

      if(_this.closest('.custom-dropdown')){
        _this.closest('.custom-dropdown').classList.add('selected');
      }

      Utility.toggleElement(this.selectContainer, 'close');
    }
  
    /**
     * Hide/Show of custom select option
     * @param _event 
     */
      manageVisibility(_event){
        if (_event) {
          event.preventDefault();
          event.stopPropagation();
        }

        if(document.body.classList.contains('template-product') && document.querySelector('[data-divtryon]') != null){
          this.customSelectAll = document.querySelector('[data-divtryon]').querySelectorAll('.custom--select');
          this.customSelectAll.forEach((element)=>{
            var isClassContains = this.selectContainer.getElementsByClassName('open');
            if (!isClassContains.length > 0) {
              if(element.classList.contains('open')){ element.classList.remove('open'); }
              if(element.querySelector('ul').classList.contains('open')){ element.querySelector('ul').classList.remove('open'); }
            }
          });
        }

        let isOpen = this.selectContainer.classList.contains('open');
        isOpen ? Utility.toggleElement(this.selectContainer, 'close') : Utility.toggleElement(this.selectContainer, 'open');
      }
  }
  customElements.define('custom-select', customSelect);
